module.exports = __webpack_public_path__ + "3ed3685bf8dd2dc726b4abbf1d668641.png";